<!-- Resume Receipt (F6). Chrome comes from styles/components/_dialogs.scss. -->
<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-md premium-dialog"
  [showHeader]="false"
>
  <div
    class="premium-dialog-container resume-dialog-container"
    (keydown)="onKeyDown($event)"
  >
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Resume Receipt</h3>
        <p class="premium-subtitle">Select a saved receipt to continue</p>
      </div>
      <button
        class="premium-close-btn"
        (click)="onClose()"
        type="button"
        aria-label="Close resume receipt dialog"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body">
      <p-table
        *ngIf="savedReceipts.length > 0"
        [value]="savedReceipts"
        [paginator]="false"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20]"
        [scrollable]="true"
        scrollHeight="320px"
        styleClass="resume-receipt-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Receipt Name</th>
            <th class="col-amount">Amount</th>
            <th class="col-updated-at">Updated At</th>
            <th class="col-action"><span class="visually-hidden">Action</span></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-receipt let-i="rowIndex">
          <tr>
            <td>
              <div class="receipt-name-cell" [title]="receipt.tempname">
                <i class="pi pi-file"></i>
                <span class="receipt-name">{{ receipt.tempname }}</span>
              </div>
            </td>
            <td class="col-amount">
              <span class="receipt-amount">
                ₹{{ receipt.amount | number: "1.2-2" }}
              </span>
            </td>
            <td class="col-updated-at">
              <div class="receipt-date-cell">
                <span class="date">{{
                  receipt.updatedAt | date: "MMM dd, yyyy"
                }}</span>
                <span class="time">{{
                  receipt.updatedAt | date: "hh:mm a"
                }}</span>
              </div>
            </td>
            <td class="col-action">
              <button
                #resumeBtn
                type="button"
                class="resume-row-btn"
                (click)="onResume(receipt.uuid)"
                [attr.aria-label]="'Resume receipt: ' + receipt.tempname"
              >
                <i class="pi pi-play"></i>
                Resume
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div *ngIf="savedReceipts.length === 0" class="resume-empty">
        <i class="pi pi-inbox"></i>
        <p class="resume-empty__title">No saved receipts</p>
        <p class="resume-empty__hint">Hold a bill with F4 and it will appear here.</p>
      </div>
    </div>

    <div class="premium-footer">
      <button
        class="premium-btn premium-btn-secondary"
        (click)="onClose()"
        type="button"
      >
        Close
      </button>
    </div>
  </div>
</p-dialog>
